module.exports = "td {\n  text-align: left; }\n"